var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 50,
    viewBox: "0 0 47 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4579 18.7735V35.9873H11.5078V17.8809",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51855 19.7803L23.4827 1.67383L43.4383 19.7803",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4658 1.67383H35.4577V7.71222",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0635 25.9854C21.372 25.9854 23.0567 27.6831 23.0567 31.0173",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0635 21.9678C23.022 21.9678 27.0426 26.0196 27.0426 31.0166",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0635 17.9424C25.2277 17.9424 31.0372 23.797 31.0372 31.0168",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.0627,
    cy: 30.0102,
    rx: 0.907464,
    ry: 0.914511,
    fill: "#2D97E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0918 32.5039H44.463V37.7022",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2197 36.1367V45.2293",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2206 48.3265C32.0695 48.3265 32.7577 47.633 32.7577 46.7775C32.7577 45.922 32.0695 45.2285 31.2206 45.2285C30.3718 45.2285 29.6836 45.922 29.6836 46.7775C29.6836 47.633 30.3718 48.3265 31.2206 48.3265Z",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4628 40.8011C45.3117 40.8011 45.9999 40.1076 45.9999 39.2521C45.9999 38.3966 45.3117 37.7031 44.4628 37.7031C43.6139 37.7031 42.9258 38.3966 42.9258 39.2521C42.9258 40.1076 43.6139 40.8011 44.4628 40.8011Z",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7089 25.4241C43.5578 25.4241 44.246 24.7306 44.246 23.8751C44.246 23.0197 43.5578 22.3262 42.7089 22.3262C41.86 22.3262 41.1719 23.0197 41.1719 23.8751C41.1719 24.7306 41.86 25.4241 42.7089 25.4241Z",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5879 28.8728H42.7087V25.4248",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9084 32.5039H2.53711V37.7022",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53705 40.8011C3.38593 40.8011 4.0741 40.1076 4.0741 39.2521C4.0741 38.3966 3.38593 37.7031 2.53705 37.7031C1.68816 37.7031 1 38.3966 1 39.2521C1 40.1076 1.68816 40.8011 2.53705 40.8011Z",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29095 25.4241C5.13984 25.4241 5.828 24.7306 5.828 23.8751C5.828 23.0197 5.13984 22.3262 4.29095 22.3262C3.44207 22.3262 2.75391 23.0197 2.75391 23.8751C2.75391 24.7306 3.44207 25.4241 4.29095 25.4241Z",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4118 28.8728H4.29102V25.4248",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4072 36.1367V41.9476",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4072 45.0452C16.2561 45.0452 16.9442 44.3517 16.9442 43.4963C16.9442 42.6408 16.2561 41.9473 15.4072 41.9473C14.5583 41.9473 13.8701 42.6408 13.8701 43.4963C13.8701 44.3517 14.5583 45.0452 15.4072 45.0452Z",
    stroke: "#2D97E9",
    strokeWidth: 1.82902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondTitleIcon);
export default __webpack_public_path__ + "static/media/secondTitleIcon.877a596de18be577e49f3d7140924f45.svg";
export { ForwardRef as ReactComponent };